<template>
  <div class="index">


    <el-image aria-hidden="true" class="bgs" src="/static/image/problem1/BG1.png"></el-image>

    <div class="bg">
      <p tabindex="1" id="title-p" role="text" aria-label="第一题，你会在意每天的穿搭吗？">
        <el-image aria-hidden="true"  class="title" src="/static/image/problem1/题目.png"></el-image>
      </p>
      <div :aria-hidden="getfocus">
        <div class="options">
          <div>
            <img @click="problema_btn()" :aria-checked="problema_checked" role="radio" aria-label="A，是，我精心挑选每天穿的衣服"
                 class="options_a" :src="problema_src"/>
          </div>

          <div>
            <img @click="problemb_btn()" :aria-checked="problemb_checked" role="radio" aria-label="B，不是，随便套件衣服就足够了"
                 class="options_b" :src="problemb_src"/>
          </div>

          <div>
            <img @click="problemc_btn()" :aria-checked="problemc_checked" role="radio" aria-label="C，非必要不穿衣服"
                 class="options_c" :src="problemc_src"/>
          </div>


        </div>

        <div>
          <el-image role="text" aria-label="无障碍贴士，臭美不分你我，很多视障朋友也很注重穿衣搭配喔~" class="tips"
                    src="/static/image/problem1/小贴士.png"></el-image>

        </div>


        <div class="btns">
          <!--        &lt;!&ndash;     <div class="btn">&ndash;&gt;-->
          <!--        &lt;!&ndash;       <el-image role="button" aria-label="上一题" @click="previous()" src="/static/image/problem1/上一题.png"></el-image>&ndash;&gt;-->
          <!--&lt;!&ndash;      </div>&ndash;&gt;-->
          <div class="btn1">
            <el-button aria-label="下一题" @click="onSubmit()"></el-button>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>

import utils from "../utils/util"
import Common from "../utils/Common";

export default {
  name: 'problem1',
  data() {
    return {
      getfocus: true,
      problema_checked: false,
      problemb_checked: false,
      problemc_checked: false,
      problema_src: "/static/image/problem1/选项A.png",
      problemb_src: "/static/image/problem1/选项B.png",
      problemc_src: "/static/image/problem1/选项C.png",
    }
  },
  mounted() {

    this.$nextTick(function () {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        setTimeout((() => {
          this.getfocus = false
        }), 600);
      } else {
        this.getfocus = false
      }

      // 适配UI
      utils.adaptUI()

      document.getElementById('title-p').focus()

    })
  },
  methods: {

    // 选项A
    problema_btn() {
      this.problema_checked = true
      this.problema_src = "/static/image/problem1/选项A-选中效果.png"
      this.problemb_checked = false
      this.problemc_checked = false
      this.problemb_src = "/static/image/problem1/选项B.png"
      this.problemc_src = "/static/image/problem1/选项C.png"
    },
    // 选项B
    problemb_btn() {
      this.problemb_checked = true
      this.problemb_src = "/static/image/problem1/选项B-选中效果.png"
      this.problema_checked = false
      this.problemc_checked = false
      this.problema_src = "/static/image/problem1/选项A.png"
      this.problemc_src = "/static/image/problem1/选项C.png"
    },
    // 选项C
    problemc_btn() {
      this.problemc_checked = true
      this.problemc_src = "/static/image/problem1/选项C-选中效果.png"
      this.problema_checked = false
      this.problemb_checked = false
      this.problema_src = "/static/image/problem1/选项A.png"
      this.problemb_src = "/static/image/problem1/选项B.png"
    },


    // 下一题
    onSubmit() {
      if (this.problema_checked === false && this.problemb_checked === false && this.problemc_checked === false) {
        this.$message({
          message: '选择选项后再继续哦~',
          type: 'warning',
          center: true,
          duration:2000,
        });
      } else {
        this.$router.replace('/Problem2')
      }
    },
    // 上一题
    previous() {
      this.$router.replace('/game')
    }

  }
}
</script>

<style scoped>


.title {
  left: 25%;
  width: 100%;
  margin-top: 20%;
}


.options_a {
  margin-left: 15%;
  width: 70%;
}

.options_b {
  margin-left: 15%;
  width: 70%;
  margin-top: 5%;
}

.options_c {
  margin-left: 15%;
  width: 70%;
  margin-top: 5%;
}

.tips {
  left: 15%;
  width: 70%;
  margin-top:5%;
  /*pointer-events: none;*/
}


.index {
  height: 100vh;
  background-image: url("/static/image/problem1/BG.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.bg {
  position: absolute;
  z-index: 1;
  top: 1px;
  left:0;
  right:0;
}

.bgs {
  left: 5%;
  margin-top: 1.5%;
  width: 90%;
  height: 97%;

}


/*去掉获得焦点的边框*/
p {
  outline: none;
}




.btn1 {
  float: right;
  margin-right: 12%;
  margin-top: 5%;
}

.btns {
  text-align: center;
}


.el-button {
  width: 110px;
  height: 40px;
  background: url("/static/image/problem1/下一题.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}


</style>





// WEBPACK FOOTER //
// src/components/home/problem1.vue